export default {
    'logout': 'Вы вышли из системы',
    'Error: Network Error': 'Ошибка соединения по сети',
    'Error: Request failed with status code 500': 'Запрос не выполнен<br>[http status code: 500]'
}